import {Component, Input, OnDestroy, ViewChild} from '@angular/core';
import {MatMenuTrigger} from "@angular/material/menu";
import {ProfileService} from "../profile/profile.service";
import {Config} from "../universal-config";
import {Subscription} from "rxjs";
import {GetNimbusPopupService} from "./get-nimbus-popup.service";
import {NIM_AUTH_TYPE} from "../auth-form/auth.model";

@Component({
  selector: 'nns-header',
  template: `
    <div class="nns-wrapper"
      flex layout="row" layout-align-sm="start center"
      [ngClass]="{
        'nns-wrapper__right': branding && branding.sharesLogoStoredFileUUID && branding.sharesLogoPosition == 'right',
        'nns-wrapper__center': branding && branding.sharesLogoStoredFileUUID && branding.sharesLogoPosition == 'center'
        }"
      >
      <div class="nns-header-content" flex layout="row" layout-align="stretch center">
        <div
          [matMenuTriggerFor]="myDrop"
          (click)="focusFormInput()"
          #myTrigger="matMenuTrigger"
          class="nns-menu-trigger"
        ></div>

        <nns-get-nimbus
          *ngIf="!branding || !branding.sharesLogoStoredFileUUID"
          flex="none"
          clickOutside
          [profile]="profile"
          (click)="handleGetNimbusClick()"
        ></nns-get-nimbus>

        <nns-branding-logo
          *ngIf="branding && branding.sharesLogoStoredFileUUID && branding.sharesLogoStoredFileUUID != null"
          [sharesLogo]="branding.sharesLogoStoredFileUUID"
          [sharesLogoLink]="branding.sharesLogoLink"
          [visual]="visual"
          ></nns-branding-logo>

        <mat-menu #myDrop="matMenu" class="m-auth-drop nns-theme-{{ visual.theme }}">
          <div (click)="$event.preventDefault();$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <nim-webshare-auth-form
              id="nim-get-nimbus-auth-form"
              (nimClose)="menuTrigger.closeMenu()"
              (nimSubmit)="handleSignup($event)"
              [viewType]="1"
              [isShowClose]="true"
              [termsLink]="termsUrl"
              [otpLink]="contactUrl"
              [authUrl]="authUrl"
            >
            </nim-webshare-auth-form>
          </div>
        </mat-menu>
      </div>
      <nns-header-actions flex="none" layout="row" layout-align="end center"
        [profile]="profile"
        [attachment]="attachment"
        [login]="login"
        [visual]="visual"
        [note]="note"
        [share]="share"
        [shareCopy]="shareCopy"
        [branding]="branding"
        [childrenNotesCount]="childrenNotesCount"
        [shareOrganization]="shareOrganization"
        [workspaces]="workspaces"
        clickOutside
      ></nns-header-actions>
    </div>
  `,
  styles: [`
    :host {
      width:100%;
      min-width:320px;
      background:#FFFFFF;
      border-bottom:1px solid #F5F5F5;
      position:relative;
      z-index: 3;
    }
    .nns-wrapper {
      max-width:1600px;
      min-width:320px;
      min-height:56px;
      margin:0 auto;
      padding:0 10px;
      position:relative;
      box-sizing:border-box;
      z-index:75;
    }
    .nns-menu-trigger{
      opacity: 0;
    }

    :host.nns-fullscreen {transform:translate(0, -100%); position:absolute;}

    .nns-header-title {display:none;}
    .nns-header-title-button {
      display:block;
      background:none;
      border:none;
      color:#fff;
      font-size:15px;
      font-weight:bold;
      display:block;
      text-align:left;
      width:auto;
      max-width:100%;
    }
    .nns-header-title-icon {width:36px;}
    .nns-header-title-text {
      margin:0 0 0 10px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      display:block;
    }

    nns-get-nimbus {
      position:relative;
      margin:0 10px 0 0;
      display:block;
    }

    .nns-wrapper__right{
      flex-direction: row-reverse;
    }
    .nns-header-content{
      height: 56px;
    }

    .nns-wrapper__right .nns-header-content{
      justify-content: flex-end;
    }

    .nns-wrapper__right nns-header-actions{
      position: relative;
    }

    .nns-wrapper__right ::ng-deep nns-header-profile .nns-header-profile-menu{
      position: unset;
    }

    .nns-wrapper__right ::ng-deep nns-header-profile .nns-header-profile-dropdown{
      left: 0;
      right: auto;
    }

    .nns-wrapper__right ::ng-deep nns-header-profile .nns-header-profile-dropdown-inner{
      padding-top: 0;
    }

    .nns-wrapper__right ::ng-deep nns-save-action .nns-save-button-dropdown{
      left: 0;
      right: auto;
    }

    .nns-wrapper__right ::ng-deep .nns-header-save, .nns-wrapper__right ::ng-deep nns-save-action{
      position: unset;
    }

    .nns-wrapper__right ::ng-deep nns-save-action .nns-save-button-dropdown-inner{
      padding-top: 0;
    }

    .nns-wrapper__center .nns-header-content{
      width: 33%;
      margin-left: 33%;
      justify-content: center;
    }

    .nns-wrapper__center nns-header-actions{
      width: 33%;
    }

    @media only screen and (max-width: 768px) {
      :host.nns-fullscreen {transform:none; position:relative;}
      .nns-header-title {display:block;}

      :host.nns-branding-logo .nns-wrapper__center .nns-header-content{
        width: 100%;
        margin-left: 0;
      }
      :host.nns-branding-logo .nns-header-title,
      :host.nns-branding-logo nns-header-actions{
        display: none;
      }
    }
  `, `
    :host-context(.nns-fullwidth) .nns-wrapper{
      max-width: 100%;
    }
    :host-context(.nns-theme-night) {
      background: #292E32;
      border-bottom-color: #3B3B3B;
    }
  `]
})

export class HeaderComponent implements OnDestroy {
  @Input() profile;
  @Input() attachment;
  @Input() visual;
  @Input() login;
  @Input() note;
  @Input() share;
  @Input() branding;
  @Input() shareCopy;
  @Input() childrenNotesCount;
  @Input() shareOrganization;
  @Input() workspaces;

  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  termsUrl;
  contactUrl;
  authUrl;

  signupPopupType: 'head_left' | 'print';

  authPopupSubscribe$ = new Subscription();

  constructor(
    private _profileService: ProfileService,
    private _config: Config,
    private _getNimbusPopupService: GetNimbusPopupService,
  ) {
    this.termsUrl = this._config.get('NIMBUS_TERMS_URL');
    this.contactUrl = this._config.get('NIMBUS_CONTACT_URL');
    this.authUrl = this._config.get('AUTH_API_URL');
    this.authPopupSubscribe$.add(
      this._getNimbusPopupService.openGetNimbusAuthPopup$.subscribe(() => {
        this.signupPopupType = 'print';
        this.openAuthPopup();
      })
    )
  }

  openAuthPopup() {
    this.menuTrigger.openMenu();
    this.focusFormInput();
  }

  focusFormInput() {
    const input: HTMLInputElement = document.querySelector('#nim-get-nimbus-auth-form input[name="email"]')
    input.focus();
  }

  handleSignup(formResult) {
    this._profileService.applyAuth(formResult, NIM_AUTH_TYPE.SIGNUP, this.signupPopupType);
    this._profileService.showSignUpSuccessToast();
    this.menuTrigger.closeMenu();
  }

  handleGetNimbusClick() {
    if(!this.profile) {
      this.signupPopupType = 'head_left';
      this.openAuthPopup();
    }
  }

  ngOnDestroy() {
    this.authPopupSubscribe$.unsubscribe();
  }
}
